import { CourseCard } from '@/components/partial/course-card';
import { Carousel } from '@/components/shared/carousel';
import { useCatalogSearch } from '@/data/catalog/search';
import { CardsSkeleton } from '@/packages/home/components/skeleton';

// Os ids de cursos são hardcoded aqui porque é uma seção específica e que não tem ponte com o backend
const DEV_IDS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const PROD_IDS = [
  153561, 187566, 187572, 159082, 191249, 191677, 191680, 191890, 191897,
  118262, 191898, 148374, 148375, 191226,
];

const isDev = import.meta.env.DEV;

const queryParams = {
  filters: { ids: isDev ? DEV_IDS : PROD_IDS },
};

export const IaCourses = () => {
  const { data: courses, isLoading } = useCatalogSearch(queryParams);

  if (isLoading) return <CardsSkeleton withTextSkeleton={false} />;

  if ((!isLoading && !courses?.items?.length) || !courses) return null;

  const slidesComponents = courses?.items?.map((slide, idx) => {
    return <CourseCard data={slide} key={slide.id + idx} />;
  });

  return <Carousel slidesComponents={slidesComponents} />;
};
